export default __webpack_public_path__ + "static/media/shelf.ea4acc1c.svg";